import { TFunction } from "i18next";
import { Variants } from "motion/react";

import { FormatDateTimeNormalizedFn, IAuditLogNormalized } from "@ryde/shared";

export const rideHistoryHeaders = {
  updateTime: "ride.history.updateTime",
  user: "ride.history.user",
  rideTime: "ride.history.rideTime",
  status: "ride.history.status",
  supplier: "ride.history.supplier",
  vehicleType: "ride.history.vehicleType",
  startStation: "ride.history.startStation",
  endStation: "ride.history.endStation",
  passengers: "ride.history.passengers",
  passengerNames: "ride.history.passengerNames",
  KM: "ride.history.KM",
  duration: "ride.history.duration",
  price: "ride.history.price",
} as const;
export type RideHistoryHeaderKeys = keyof typeof rideHistoryHeaders;

export interface IRideHistoryHeadersGetterArguments {
  item: IAuditLogNormalized;
  formatDateTimeNormalized: FormatDateTimeNormalizedFn;
  formatDateTimeWithSecondsNormalized: FormatDateTimeNormalizedFn;
  translationFn: TFunction<"translation", undefined>;
  translateLabel: (
    label: string | null | undefined,
    translationPath?: string,
  ) => string;
}

export const noNeedToCheckPrevKeys = ["updateTime", "user"];
export const expandVariants: Variants = {
  collapsed: {
    height: 0,
    opacity: 0,
    transition: {
      duration: 0.3,
      ease: "easeInOut",
    },
  },
  expanded: {
    height: "auto",
    opacity: 1,
    transition: {
      duration: 0.3,
      ease: "easeInOut",
    },
  },
};
